export default __webpack_public_path__ + "static/media/1262.4b7a2372.png";